import { Injectable, inject, signal, computed } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { map, switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { ArrayService } from 'ngx-unificator/services';
import { LanguageService } from './language.service';

export enum BankingType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'cashout'
}

export type PaymentType = {
  deposit: PaymentTypeItem[],
  withdraw: PaymentTypeItem[],
}

export type PaymentTypeItem = {
  DepositLimit: string;
  Withdrawals: string;
  Fees: string;
  id: number;
  slug: string;
  Info: string;
  HideOnDesk: string;
  Image: string;
  IsCrypto: string;
}

@Injectable({
  providedIn: 'root',
})
export class BankingService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _array = inject(ArrayService);
  private _lang = inject(LanguageService);

  public _payments = signal<PaymentType>({
    deposit: [],
    withdraw: [],
  });

  public depositPayments = computed(() => this._payments().deposit);
  public withdrawPayments = computed(() => this._payments().withdraw);
  public mergedPayments = computed(() => this._array.uniqueBy('id',
    [...this._payments().deposit, ...this._payments().withdraw]));

  public fetchPayments() {
    this._lang.langChange$.pipe(
      switchMap(() => combineLatest([
        this.getPaymentMethodsByType('deposit'),
        this.getPaymentMethodsByType('cashout'),
      ])),
    ).subscribe(([deposit, withdraw]) => {
      this._updatePaymentStateEntities({ deposit, withdraw });
    });
  }

  public getPaymentMethodsByType(type: string, sort_auth_player = 0) {
    return this._api.paymentList({ type, sort_auth_player }).pipe(
      map(response => this._mapper.mapCmsData(response.data, {
        id: 'id',
        slug: 'slug',
      })),
      map((list: PaymentTypeItem[]) => list.filter(e => e.id)),
      map((list: PaymentTypeItem[]) => list.map(item => {
          return {
            ...item,
            image: `/assets/svg/payments/fiat/color/${item.slug}.svg`,
          };
        }),
      ));
  }

  private _updatePaymentStateEntities(entity: Partial<PaymentType>) {
    this._payments.update(state => {
      return {
        ...state,
        ...entity,
      };
    });
  }
}
